"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides helper methods for configuration.
 */
const ConfigHelper = {
    /**
     * Parse a string into a boolean.
     * @param value
     * @param defaultValue
     */
    toBoolean(value, defaultValue) {
        if (typeof value === 'boolean') {
            return value;
        }
        return value != null ? (value === null || value === void 0 ? void 0 : value.toLowerCase().trim()) === 'true' : defaultValue;
    },
    /**
     * Parse a string into an integer.
     * @param value
     * @param defaultValue
     * @return a number or undefined if no default value
     */
    toInteger(value, defaultValue) {
        if (typeof value === 'number') {
            return value;
        }
        return value ? Number.parseInt(value, 10) : defaultValue;
    },
    /**
     * Parse a string into a number.
     * @param value
     * @param defaultValue
     * @return a number or undefined if no default value
     */
    toNumber(value, defaultValue) {
        if (typeof value === 'number') {
            return value;
        }
        return value != null ? Number.parseFloat(value) : defaultValue;
    }
};
exports.default = ConfigHelper;
//# sourceMappingURL=ConfigHelper.js.map